export const GET_E_ACCOUNTS_URL = '/e-accounts';
export const CREATE_E_ACCOUNT_URL = '/e-accounts';
export const UPDATE_E_ACCOUNT_URL = (id) => `/e-accounts/${id}`;
export const DELETE_E_ACCOUNT_URL = (id) => `/e-accounts/${id}`;

